import React from "react";

function Cateringoverview() {
    // Sample lead data (replace with API later)
    const enquiryList = [
        {
            id: 1,
            promisedLeads: 100,
            consumedLeads: 80,
            balancedLeads: 20,
            startDate: "2025-09-01",
            endDate: "2025-09-30",
            status: "Active",
        },
        {
            id: 2,
            promisedLeads: 50,
            consumedLeads: 50,
            balancedLeads: 0,
            startDate: "2025-08-01",
            endDate: "2025-08-31",
            status: "Completed",
        },
        {
            id: 3,
            promisedLeads: 75,
            consumedLeads: 30,
            balancedLeads: 45,
            startDate: "2025-09-10",
            endDate: "2025-09-25",
            status: "In Progress",
        },
    ];

    return (
        <div>
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "15px",
                    fontSize: "16px",
                }}
            >
                <thead>
                    <tr style={{ backgroundColor: "rgb(177 93 198)", color: "white" }}>
                        <th style={thStyle}>Order Id</th>
                        <th style={thStyle}>Date</th>
                        <th style={thStyle}>Time</th>
                        <th style={thStyle}>Transaction Id</th>
                        <th style={thStyle}>Amount</th>
                        <th style={thStyle}>Review</th>
                        <th style={thStyle}>Status</th>
                    </tr>
                </thead>
                <tbody>

                    <tr>
                        <td style={tdStyle}>
                            001
                        </td>
                        <td style={tdStyle}>
                            11-05-2025
                        </td >
                        <td style={tdStyle}>
                            03:45:00
                        </td >
                        <td style={tdStyle}>
                            payturez-hjsgs
                        </td>
                        <td style={tdStyle}>
                            5000
                        </td>
                        <td style={tdStyle}>
                            -
                        </td>
                        <td style={tdStyle}>
                            Paid
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    );
}

// Inline styles
const thStyle = {
    border: "1px solid #ccc",
    padding: "10px",
    textAlign: "left",
    fontWeight: "bold",
};

const tdStyle = {
    border: "1px solid #ccc",
    padding: "10px",
};

export default Cateringoverview;
